import Decimal from "decimal.js";
import { useTranslation } from "react-i18next";
import { useRoundStore } from "../../state/roundStore.js";
import type { BetRowData } from "./useBetHistory.js";

export function BetRow({ bet }: { bet: BetRowData }) {
  const { t } = useTranslation();
  const decimals = useRoundStore(
    (state) => state.config?.currencies.find((currency) => currency.code === bet.currency)?.decimals ?? 2,
  );
  return (
    <tr className={bet.win !== undefined ? "cx-bet-row cx-bet-row--won" : "cx-bet-row"}>
      <td>
        <span className="flex items-center gap-2">
          <span aria-hidden="true" className="cx-avatar">
            {Array.from(bet.nick)[0]}
          </span>
          <span className="min-w-0">
            <span className="block max-w-28 truncate">{bet.nick}</span>
            {bet.isBot ? <span className="text-xs text-muted">{t("bets.bot")}</span> : null}
            {bet.status ? (
              <span className="block text-xs text-muted">{t(`bets.status.${bet.status}`)}</span>
            ) : null}
          </span>
        </span>
      </td>
      <td>
        {new Decimal(bet.amount).toFixed(decimals)}
        <span className="block text-xs text-muted">{bet.currency}</span>
      </td>
      <td>
        {bet.multiplier === undefined
          ? t("bets.none")
          : t("bets.factor", { value: bet.multiplier.toFixed(2) })}
      </td>
      <td>{bet.win === undefined ? t("bets.none") : new Decimal(bet.win).toFixed(decimals)}</td>
    </tr>
  );
}
